import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/** 江西检测签到查询接口。 */
export const signService = {
  page: params => axios.get(`${iffApi}/jxxf/jc/sign`, { params })
};
